"use strict";
// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See LICENSE.txt for license information.
Object.defineProperty(exports, "__esModule", { value: true });
exports.ServiceEnvironment = exports.CollapsedThreads = void 0;
var CollapsedThreads;
(function (CollapsedThreads) {
    CollapsedThreads["DISABLED"] = "disabled";
    CollapsedThreads["DEFAULT_ON"] = "default_on";
    CollapsedThreads["DEFAULT_OFF"] = "default_off";
    CollapsedThreads["ALWAYS_ON"] = "always_on";
})(CollapsedThreads || (exports.CollapsedThreads = CollapsedThreads = {}));
var ServiceEnvironment;
(function (ServiceEnvironment) {
    ServiceEnvironment["PRODUCTION"] = "production";
    ServiceEnvironment["TEST"] = "test";
    ServiceEnvironment["DEV"] = "dev";
})(ServiceEnvironment || (exports.ServiceEnvironment = ServiceEnvironment = {}));
